type Props = React.SVGProps<SVGSVGElement> & {
  size?: number;
  className?: string;
};

export function MaterialInventoryIcon(props: Props) {
  const size = props.size ?? 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="currentColor"
      viewBox="0 0 16 16"
      {...props}
    >
      <mask
        id="a"
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          strokeWidth="1"
          d="m10.333 11.417 3.3-3.3a.632.632 0 0 1 .467-.184c.189 0 .344.061.467.184a.632.632 0 0 1 .183.466.632.632 0 0 1-.183.467L10.8 12.817a.64.64 0 0 1-.467.2.64.64 0 0 1-.466-.2l-1.9-1.9a.632.632 0 0 1-.184-.467c0-.189.061-.345.184-.467a.632.632 0 0 1 .466-.183c.19 0 .345.061.467.183l1.433 1.434Zm-7 2.583c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h2.784c.122-.389.36-.708.716-.958S7.578.667 8 .667a2 2 0 0 1 1.192.375c.35.25.586.57.708.958h2.767c.366 0 .68.13.941.392.261.26.392.575.392.941V6a.645.645 0 0 1-.192.475.645.645 0 0 1-.475.192.645.645 0 0 1-.475-.192.645.645 0 0 1-.191-.475V3.333h-1.334v1.334a.645.645 0 0 1-.191.475.645.645 0 0 1-.475.191H5.333a.645.645 0 0 1-.475-.191.645.645 0 0 1-.191-.475V3.333H3.333v9.334h3.334c.189 0 .347.063.475.191a.645.645 0 0 1 .191.475.645.645 0 0 1-.191.475.645.645 0 0 1-.475.192H3.333ZM8 3.333a.645.645 0 0 0 .475-.191.645.645 0 0 0 .192-.475.645.645 0 0 0-.192-.475A.645.645 0 0 0 8 2a.645.645 0 0 0-.475.192.645.645 0 0 0-.192.475c0 .189.064.347.192.475A.645.645 0 0 0 8 3.333Z"
        />
      </g>
    </svg>
  );
}
